import { Component, ChangeDetectionStrategy, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';

import { DarkModeService } from 'projects/ngx-messaging/src/core/services/dark-mode.service';
import { IconsService } from 'projects/ngx-messaging/src/core/services/icons.service';
import { AppStateWithChat } from 'projects/ngx-messaging/src/modules/chat/store/chat.reducer';
import { selectIsLoadingResolve } from 'projects/ngx-messaging/src/store/app.selectors';
import { environment } from 'src/environments/environment';

import { Store } from '@ngrx/store';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class AppComponent {
  title = 'messaging-ui';

  private store = inject(Store<AppStateWithChat>);
  isLoadingResolve = toSignal(this.store.select(selectIsLoadingResolve), { initialValue: false });

  constructor(
    private translateService: TranslateService,
    private iconsService: IconsService,
    private darkModeService: DarkModeService
  ) {
    this.setTranslations();
    this.setTheme();
    this.setIcons();
  }

  setIcons(): void {
    this.iconsService.loadIcons(environment.assetsNgxMessaging);
  }

  setTranslations(): void {
    const lang = localStorage.getItem('lang') || 'en-GB';
    this.translateService.setDefaultLang(lang);
    this.translateService.use(lang);
  }

  setTheme(): void {
    this.darkModeService.setTheme();
  }
}
